import script from "./PhysicalMarketingView.vue?vue&type=script&setup=true&lang=js"
export * from "./PhysicalMarketingView.vue?vue&type=script&setup=true&lang=js"

import "./PhysicalMarketingView.vue?vue&type=style&index=0&id=78250bf8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78250bf8"]])

export default __exports__